//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    slidesNo: {
      type: Number,
      default: 3,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sliderOptions: {
        arrows: true,
        slidesToShow: this.slidesNo,
        infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        centerMode: false,
        dots: false,
        nextArrow:
          '<div class="infinite-next-btn pr-md-5"><span class="icon-arrow-right slider-next"></span></div>',
        prevArrow:
          '<div class="infinite-prev-btn"><span class="icon-arrow-left slider-prev"></span></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    };
  },
  methods: {
    useMoment(newsDate) {
      if (newsDate != "") {
        return this.$moment(newsDate).format("MMM DD, YYYY");
      }
    },

    truncate(str, no_words) {
      if (str && no_words != "") {
        if (
          str
            .replace(/(^\s*)|(\s*$)/gi, "")
            .replace(/[ ]{2,}/gi, " ")
            .replace(/\n /, "\n")
            .split(" ").length > no_words
        ) {
          return str.split(" ").splice(0, no_words).join(" ") + "...";
        } else {
          return str;
        }
      }
    },
  },
};
